angular.module('mtic').service('GenericPopup', function ($log, $compile, $rootScope, $timeout) {
  var instance = null;
  var template =
    `<div class="generic-popup-container">
      <div class="mticCard">
        <div class="mticCard__header">
          <span class="mticCard__headerText" ng-cloak>{{headerText}}</span>
          <span class="mticCard__close" ng-click="close()">
          <span class="char-icon">&#10006;</span>
          <i class="fa fa-times-circle" aria-hidden="true"></i>
        </span>
        </div>
        <div class="mticCard__body">
          <span class="mticCard__genericMessage" ng-cloak>{{messageText}}</span>
          <a class="button mticCard__button" ng-click="close()">Close</a>
        </div>
      </div>
    </div>`;

  function open(header, message){
    instance = angular.element(template)[0];
    $compile(instance)(Object.assign($rootScope.$new(true), {
      headerText: header,
      messageText: message,
      close: close
    }));
    $timeout(()=>{
      document.body.append(instance);
    })
  }
  function close(){
    if(instance){
      instance.remove();
    }
  }

  return {
    open: open,
    close: close
  }
})
